import { GET_CATEGORY_NEWS_VIDEOS, GET_FANTASY_ARTICLE_OF_CATEGORY, GET_SERIES_NEWS_VIDEOS } from '@graphql/series/home.query'
import { LIST_SERIES_TEAMS } from '@graphql/series/teams.query'
import { GET_CATEGORY_BY_ID } from '@graphql/category/category.query'
import { FETCH_SERIES_DESCRIPTION, FETCH_TEAM_VENUE, FIXTURES_LIST } from '@graphql/series/fixtures.query'
import { GET_ROUNDS, GET_STANDING_DATA } from '@graphql/series/standings.query'
import { FETCH_SERIES_STATS_TYPE, STATS, MATCH_TYPES } from '@graphql/series/stats.query'
import { GET_ARCHIVES } from '@graphql/series/archives.query'
import { TOP_PLAYERS } from '@graphql/series/topPlayers.query'
import queryGraphql from '@shared/components/queryGraphql'
import { GET_TEAM_PLAYER } from '@graphql/series/squads.query'
import { LIST_SERIES_FANTASY_TIPS } from '@graphql/series/fantasy-tips.query'
import { SERIES_MINI_SCORECARD } from '@graphql/home/home.query'
import { GET_SUB_PAGE_BY_SLUG } from '@graphql/seo/seo.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'

export const payload = (limit) => {
  return { nSkip: 1, nLimit: limit, sSortBy: 'dCreated', nOrder: -1 }
}

export const categorySlug = ['news', 'videos', 'fantasy-articles', 'fixtures', 'standings', 'stats', 'archives', 'photos', 'teams', 'squads', 'fantasy-tips']
async function getSeriesScoreCard(category) {
  if (category?.eType === 'as') {
    const { data: scoreCard } = await queryGraphql(SERIES_MINI_SCORECARD, { input: { _id: category?.iSeriesId } })
    return scoreCard?.listSeriesScorecard || []
  } else return []
}

async function getStatsData({ category, seriesData }) {
  // Batting
  const battingMostRuns = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_most_runs')
  const battingHighestStrikerate = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_highest_strikerate')
  const battingHighestAverage = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'batting_highest_average')
  // Bowling
  const bowlingTopWickeTakers = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_top_wicket_takers')
  const bowlingBestEconomy = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_best_economy_rates')
  const bowlingBestAverages = seriesData.fetchSeriesStatsTypes.find(obj => obj.sType === 'bowling_best_averages')
  const [statsDataBattingMostRuns, statsDataBattingHighestStrikerate, statsDataBattingHighestAverage, statsDataBowlingTopWickeTakers, statsDataBowlingBestEconomy, statsDataBowlingBestAverages] = await parallelCalls([
    // Batting
    queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: battingMostRuns._id } }),
    queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: battingHighestStrikerate._id } }),
    queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: battingHighestAverage._id } }),
    // Bowling
    queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: bowlingTopWickeTakers._id } }),
    queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: bowlingBestEconomy._id } }),
    queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: bowlingBestAverages._id } })
  ])
  return { statsDataBattingMostRuns, statsDataBattingHighestStrikerate, statsDataBattingHighestAverage, statsDataBowlingTopWickeTakers, statsDataBowlingBestEconomy, statsDataBowlingBestAverages }
}

export async function getCategorySSRData(seo, tabType, isAmp, query, resolvedUrl) {
  try {
    const {
      data: { getCategoryByIdFront }
    } = await queryGraphql(GET_CATEGORY_BY_ID, { input: { _id: seo?.iId } })
    const category = getCategoryByIdFront
    let rData = { type: tabType || 'home', data: category }
    if (category?.eType === 'as') { // Series
      const { data: subPages } = await queryGraphql(GET_SUB_PAGE_BY_SLUG, { input: { sSlug: seo?.sSlug } })
      const scoreCard = await getSeriesScoreCard(category)
      rData = { ...rData, seriesScoreCard: scoreCard, subPages: subPages?.getSeosBySlug }

      if (tabType === 'news') {
        const { data: newsData } = await queryGraphql(GET_SERIES_NEWS_VIDEOS, { input: { ...payload(isAmp ? 32 : 16), iSeriesId: category?.iSeriesId, eType: 'n' } })
        rData = { ...rData, newsData: newsData?.listSeriesArticlesVideosFront?.oArticles }
      } else if (tabType === 'videos') {
        const { data: newsVideo } = await queryGraphql(
          GET_SERIES_NEWS_VIDEOS,
          {
            input: { ...payload(isAmp ? 16 : 7), iSeriesId: category?.iSeriesId, eType: 'v' }
          }
        )
        rData = { ...rData, videosData: newsVideo?.listSeriesArticlesVideosFront?.oVideos }
      } else if (tabType === 'fixtures') {
        const [fixturesData, teamData] = await parallelCalls([
          queryGraphql(FIXTURES_LIST, { input: { iSeriesId: category?.iSeriesId, nOrder: 1, sSortBy: 'dStartDate' } }),
          queryGraphql(FETCH_TEAM_VENUE, { input: { iSeriesId: category?.iSeriesId } })
        ])
        rData = { ...rData, fixturesData, teamData }
      } else if (tabType === 'standings') {
        const [roundData, standingData] = await parallelCalls([
          queryGraphql(GET_ROUNDS, { input: { iSeriesId: category?.iSeriesId } }),
          queryGraphql(GET_STANDING_DATA, { input: { iRoundId: null, iSeriesId: category?.iSeriesId } })
        ])
        rData = { ...rData, roundData, standingData }
      } else if (tabType === 'stats') {
        const { data: seriesData } = await queryGraphql(FETCH_SERIES_STATS_TYPE, { input: { eGroupTitle: 'All' } })
        let selectedStats
        if (seo?.eSubType !== 'st') {
          const lastSlug = seo?.sSlug?.split('/')?.slice(-1)[0]?.replaceAll('-', '_')
          selectedStats = seriesData?.fetchSeriesStatsTypes.filter((i) => {
            const slugType = i.sSeoType || i.sType
            return slugType === lastSlug
          })
        }
        const id = seo?.eSubType !== 'st' ? selectedStats[0]?._id : seriesData?.fetchSeriesStatsTypes[0]?._id
        if (category?.oSeries?.sSeriesType === 'tour' || category?.oSeries?.sSeriesType === 'series') {
          const { data: matchTypeData } = await queryGraphql(MATCH_TYPES, { input: { iSeriesId: category?.iSeriesId } })
          const [statsData, data] = await parallelCalls([
            queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: id, eFormat: matchTypeData?.listSeriesStatsFormat[0] } }),
            getStatsData({ seriesData, category })
          ])
          rData = { ...rData, statsData, seriesData, ...data }
        } else {
          const [statsData, data] = await parallelCalls([
            queryGraphql(STATS, { input: { iSeriesId: category?.iSeriesId, _id: id } }),
            getStatsData({ seriesData, category })
          ])
          rData = { ...rData, statsData, seriesData, ...data }
        }
      } else if (tabType === 'archives') {
        const { data: seriesArchivesData } = await queryGraphql(GET_ARCHIVES, { input: { iSeriesId: category?.iSeriesId } })
        rData = { ...rData, seriesArchivesData }
      } else if (tabType === 'teams') {
        const { data: seriesTeamData } = await queryGraphql(LIST_SERIES_TEAMS, { input: { iSeriesId: category?.iSeriesId } })
        rData = { ...rData, seriesTeamData }
      } else if (tabType === 'squads') {
        const { data: seriesTeamData } = await queryGraphql(LIST_SERIES_TEAMS, { input: { iSeriesId: category?.iSeriesId } })
        if (seriesTeamData?.listSeriesTeams?.aTeams?.length) {
          const iTeamId = query?.teamid || seriesTeamData?.listSeriesTeams?.aTeams[0]?._id
          const { data: teamPlayer } = await queryGraphql(GET_TEAM_PLAYER, { input: { iSeriesId: category?.iSeriesId, iTeamId } })
          rData = { ...rData, seriesTeamData, teamPlayer: teamPlayer?.listSeriesSquad }
        } else {
          rData = { ...rData, seriesTeamData, teamPlayer: [] }
        }
      } else if (tabType === 'fantasy-tips') {
        const { data: seriesFantasyTips } = await queryGraphql(LIST_SERIES_FANTASY_TIPS, { input: { iSeriesId: category?.iSeriesId, nOrder: -1, sSortBy: 'dStartDate' } })
        rData = { ...rData, seriesFantasyTips }
      } else { // Home
        const [sArticle, fantasyArticle, playerData, oSeriesData] = await parallelCalls([
          queryGraphql(GET_SERIES_NEWS_VIDEOS, { input: { ...payload(32), iSeriesId: category?.iSeriesId, eType: 'vn' } }),
          queryGraphql(GET_FANTASY_ARTICLE_OF_CATEGORY, { input: { ...payload(16), iId: seo?.iId } }),
          queryGraphql(TOP_PLAYERS, { input: { iSeriesId: category?.iSeriesId } }),
          queryGraphql(FETCH_SERIES_DESCRIPTION, { input: { iSeriesId: category?.iSeriesId } })
        ])
        rData = {
          ...rData,
          home: {
            seriesDescription: oSeriesData?.fetchSeriesData?.oSeries || {},
            oArticles: sArticle?.listSeriesArticlesVideosFront?.oArticles,
            oVideos: sArticle?.listSeriesArticlesVideosFront?.oVideos,
            fantasyArticle: fantasyArticle?.listFrontTagCategoryFantasyArticle
          },
          playerData
        }
      }
    } else { // Simple
      const { data: oArticles } = await queryGraphql(GET_CATEGORY_NEWS_VIDEOS, { input: { ...payload(isAmp ? 32 : 16), iCategoryId: category?._id, eType: 'n' } })
      if (category?.eType === 'fac') {
        const { data: fantasyArticle } = await queryGraphql(GET_FANTASY_ARTICLE_OF_CATEGORY, { input: { ...payload(16), iId: seo?.iId } })
        rData = {
          ...rData,
          home: { oArticles: oArticles?.listSimpleCategoryArticlesVideosFront?.oArticles, fantasyArticle: fantasyArticle?.listFrontTagCategoryFantasyArticle }
        }
      } else {
        const { data: oVideos } = await queryGraphql(GET_CATEGORY_NEWS_VIDEOS, { input: { ...payload(isAmp ? 16 : 7), iCategoryId: category?._id, eType: 'v' } })
        rData = {
          ...rData,
          home: { oArticles: oArticles?.listSimpleCategoryArticlesVideosFront?.oArticles, oVideos: oVideos?.listSimpleCategoryArticlesVideosFront?.oVideos }
        }
      }
    }
    return rData
  } catch (e) {
    console.error(e)
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
